import LegalPage from './LegalPage';

const Privacy = () => {
  return <LegalPage file="datenschutz" title="Datenschutzerklärung" />;
};

export default Privacy;
